import { Box } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { CouponField } from '../CouponField/CouponField';
import { useAppConfig } from '../../../../../../hooks/use-app-config';
import { FormattedPrice } from '../../../FormattedPrice/FormattedPrice';

interface PriceBreakdownProps {
  pricing: any;
  priceNet?: number;
  priceTotal?: number;
  tax?: number;
  discount?: number;
  showTaxValue?: boolean;
  showCouponField?: boolean;
  priceBreakdown: any;
}

export const PriceBreakdown = ({
  pricing,
  priceNet = 0,
  priceTotal = 0,
  tax = 0,
  discount = 0,
  showTaxValue = false,
  showCouponField = false,
  priceBreakdown,
}: PriceBreakdownProps) => {
  const { theme } = useAppConfig();

  const { t } = useTranslation(undefined, { keyPrefix: 'checkout' });

  return (
    <>
      {showCouponField && (
        <Box pt={1}>
          <CouponField />
        </Box>
      )}
      <div className="description-lower">
        <div className="description-footer-subtotal">
          <span>{t('subtotal')}</span>
          <FormattedPrice pricing={pricing} priceValue={priceNet} data-testid="subtotal-price" />
        </div>
        {Boolean(discount) && (
          <div className="description-footer-subtotal">
            <span>
              {t('discount')} ({priceBreakdown?.discountRatePoints}%)
            </span>
            <FormattedPrice pricing={pricing} priceValue={discount} data-testid="discount" />
          </div>
        )}
        <div className="description-footer-tax">
          <span data-testid="tax-percent">
            {t('tax')} {showTaxValue && <>({(priceBreakdown?.taxRatePoints || 0) / 100}%)</>}
          </span>
          {showTaxValue ? (
            <FormattedPrice pricing={pricing} priceValue={tax} data-testid="tax-price" />
          ) : (
            <span>–</span>
          )}
        </div>
        <div className="description-footer-total">
          <span>{t('total')}</span>
          <FormattedPrice pricing={pricing} priceValue={priceTotal} data-testid="total-price" />
        </div>
      </div>
    </>
  );
};
